import {
    AbilityBuilder,
    AbilityClass,
    ConditionsMatcher,
    mongoQueryMatcher,
    PureAbility,
} from '@casl/ability';

enum Action {
    Create = 'create',
    Edit = 'edit',
    View = 'view',
    List = 'list',
    Manage = 'manage',
    Vote = 'vote',
    Facilitate = 'facilitate',
    Proxy = 'proxy',
    Unlock = 'unlock',
    Skip = 'skip',
    Delete = 'delete',
    Download = 'download',
}

export type Entities =
    | 'Home'
    | 'Proxy'
    | 'User'
    | 'Stellar'
    | 'Footer'
    | 'Cheershub'
    | 'MyRequests'
    | 'Resources'
    | 'Admin';

export type AbilityTuple = [`${Action}`, Entities | Record<string, unknown>];

export type AppAbility = PureAbility<AbilityTuple>;

type AbilityUser = {
    roles?: {
        isGlobalAdmin?: boolean;
        isMasterGlobalAdmin?: boolean;
    };
    oneVerseRoles?: Array<{ role?: string } | string> | null;
    proxiedAs?: {
        oneVerseRoles?: Array<{ role?: string } | string> | null;
    } | null;
};

export function createUserAbility(user?: AbilityUser, rules?: AppAbility['_indexedRules']) {
    const { can, build } = new AbilityBuilder(PureAbility as AbilityClass<AppAbility>);

    const mainUserRoles = user?.roles;
    const effectiveOneVerseRoles = user?.proxiedAs?.oneVerseRoles ?? user?.oneVerseRoles;
    const hasMasterAdminRole = effectiveOneVerseRoles?.some((role: { role?: string } | string) => {
        if (typeof role === 'string') {
            return role === 'masterAdmin';
        }

        return role?.role === 'masterAdmin';
    });

    can(Action.View, 'Home');
    can(Action.View, 'MyRequests');
    can(Action.View, 'Resources');

    if (mainUserRoles?.isGlobalAdmin) {
        can(Action.Proxy, 'User');
    }

    if (hasMasterAdminRole) {
        can(Action.View, 'Admin');
    }

    const ability = build({
        conditionsMatcher: mongoQueryMatcher as ConditionsMatcher<unknown>,
    });

    if (rules) {
        ability.update(rules);
    }

    return ability;
}
